import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TabStripComponent } from '@progress/kendo-angular-layout';
import { CSEService } from '../../services/cse.service';
import { DataService } from '../../services/data.service';
import { EmployeeService } from '../../services/employees.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import {
    DataCollection
    , Employee
    , EmployeeLoadCount
    , Mode
    , QuoteOrderLine
    , SearchCarrierSalesAvailableLoads
    , SearchCarrierSalesAvailableLoadsFilter
    , SearchCarrierSalesBookedLoads
    , SearchCarrierSalesLoads
    , SearchCarrierSalesUnverifiedLoads
    , SearchEmployeeGroupRole
    , SearchEmployeeGroupRoleMap
    , SearchQuoteOrderLine
    , TrailerType
} from '../../models/models';

@Component({
    selector: 'carrier-sales',
    templateUrl: './carrier-sales.component.html',
    standalone: false
})
export class CarrierSales implements OnDestroy, OnInit {
    @ViewChild(TabStripComponent, { static: false }) public topTabStrip!: TabStripComponent;
    //@ViewChild('topTabStrip', { static: true }) public topTabStrip!: TabStripComponent;
    @HostListener('window:beforeunload', ['$event'])
    beforeunloadHandler(event) {
        event.preventDefault();
        if (this.bulkTenderLoads.length > 0) {
            event.returnValue = 'Any unsaved data will be lost, and the Bulk Tender Orders will be unlocked.';
            //console.log("beforeunloadHandler", this.quoteOrder.quoteOrderId, this.recordLockSource);
            this.clearRecordLockList();
        }
        else if (this.editedLoad.quoteOrderID > 0 && this.offerID > 0) {
            event.returnValue = 'Any unsaved data will be lost, and the Order will be unlocked.';
            this.recordLockService.clearRecordLock("QuoteOrder", this.editedLoad.quoteOrderID, this.recordLockSource);
        }
        else if (this.editedBookedLoad.quoteOrderID > 0 && this.offerID > 0) {
            event.returnValue = 'Any unsaved data will be lost, and the Order will be unlocked.';
            this.recordLockService.clearRecordLock("QuoteOrder", this.editedBookedLoad.quoteOrderID, this.recordLockSource);
        }
        return false;
    }

    public isTenderLoads: boolean = false;
    public isCarrierRepsAssignedStats: boolean = false;
    public selectedTab: string = "Orders";
    public divFlags = {
        'filters': true
    };
    private subQuoteOrderLine: Subscription | undefined;
    public availableLoads: SearchCarrierSalesAvailableLoads[] = [];
    public availableLoadsOrig: SearchCarrierSalesAvailableLoads[] = [];
    public availableLoadsFilter: SearchCarrierSalesAvailableLoadsFilter = {
        beginDate: new Date(new Date().setDate(new Date().getDate() - 1)),
        endDate: new Date(new Date().setDate(new Date().getDate() + 10)),
        isSpotExpediteContract: false,
        isRFQAllCosts: false,
        isMyLoads: false,
        isBulkTender: false,
        isNonExpired: false
    };
    public bookedLoads: SearchCarrierSalesBookedLoads[] = [];
    public bookedLoadsOrig: SearchCarrierSalesBookedLoads[] = [];
    public releasedLoads: SearchCarrierSalesLoads[] = [];
    public releasedLoadsOrig: SearchCarrierSalesLoads[] = [];
    //public bookedLoadsFilter: SearchCarrierSalesBookedLoadsFilter = {
    //    beginDate: new Date(new Date().setDate(new Date().getDate() - 1)),
    //    endDate: new Date(new Date().setDate(new Date().getDate() + 10)),
    //    isSpotExpediteContract: false,
    //    isMyLoads: false
    //};
    public unverifiedLoads: SearchCarrierSalesUnverifiedLoads[] = [];
    public unverifiedLoadsOrig: SearchCarrierSalesUnverifiedLoads[] = [];
    public bulkTenderLoads: SearchCarrierSalesAvailableLoads[] = [];
    public isCSRManager: boolean = false;
    private userName: string = "";
    public editedLoad: SearchCarrierSalesAvailableLoads = {} as SearchCarrierSalesAvailableLoads;
    public editedBookedLoad: SearchCarrierSalesAvailableLoads = {} as SearchCarrierSalesAvailableLoads;
    public quoteOrderID: number = 0;
    public originalQuoteOrderLineID: number = 0;
    public carrierID: number = 0;
    public carrierRefreshDate: Date = new Date();
    public offerRefreshDate: Date = new Date();
    public offerID: number = 0;
    public offerBatchID: number = 0;
    public carrierOfferBatchID: number = 0;

    public dashboardDate: Date = new Date();
    public cardAvailableWithoutHC: number = 0;
    public cardAvailableWithoutMaxCarrierPay: number = 0;
    public cardBookedNegativeProfit: number = 0;
    public availableWithoutHCList: SearchCarrierSalesAvailableLoads[] = [];
    public availableWithoutMaxCarrierPayList: SearchCarrierSalesAvailableLoads[] = [];
    public bookedNegativeProfitList: SearchCarrierSalesBookedLoads[] = [];
    public unverifiedInTransitList: SearchCarrierSalesUnverifiedLoads[] = [];
    public unverifiedInTransitByEmployeeList: SearchCarrierSalesUnverifiedLoads[] = [];
    public cardUnverifiedInTransitOrigList: EmployeeLoadCount[] = [];
    public cardUnverifiedInTransitList: EmployeeLoadCount[] = [];
    public isCardDetail: boolean = false;
    public cardType: string = "";
    public cardEmployeeID: number = 0;
    public searchEmployeeGroupRoles: SearchEmployeeGroupRole[] = [];
    public searchEmployeeGroupRoleMaps: SearchEmployeeGroupRoleMap[] = [];
    public employeeGroupRoleMapID: number = 0;

    public accountReps: Employee[] = [];
    public opsReps: Employee[] = [];
    public salesReps: Employee[] = [];
    //public employees: Employee[] = [];
    public modes: Mode[] = [];
    public trailerTypes: TrailerType[] = [];
    //public cities: City[] = [];
    //public filteredOrigins: Observable<City[]> = new Observable<City[]>();
    //public filteredDestinations: Observable<City[]> = new Observable<City[]>();
    public beginDate: Date;
    public endDate: Date;
    public originControl = new UntypedFormControl();
    public destinationControl = new UntypedFormControl();
    public modeId: number = 0;
    public trailerTypeId: number = 0;
    public customerId: number = 0;
    //public accountRepId: number = 0;
    //public opsRepId: number = 0;
    //public salesRepId: number = 0;
    public orderCreatedByEmployeeId: number = 0;
    public carrierCode: string = '';
    public customerCode: string = '';
    public accountManager: string = '';
    public opsRep: string = '';
    public csr: string = '';
    public orderCreatedBy: string = '';

    private recordLockAction: string = "";
    private recordLockSource: string = "Procurement";

    orderPlannedForm: UntypedFormGroup = new UntypedFormGroup({
        originControl: new UntypedFormControl(''),
        destinationControl: new UntypedFormControl('')
    });

    constructor(private cseService: CSEService, private dataService: DataService,
        private employeeService: EmployeeService, private notificationService: NotificationService,
        private orderService: OrderService, private recordLockService: RecordLockService,
        public utilService: UtilService, private titleService: Title) {

        this.titleService.setTitle("Procurement");

        var today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        this.beginDate = new Date(today.setDate(today.getDate() - 1));
        this.endDate = new Date(today.setDate(today.getDate() + 10));
        this.beginDate.setHours(0);
        this.beginDate.setMinutes(0);
        this.beginDate.setSeconds(0);
        this.endDate.setHours(0);
        this.endDate.setMinutes(0);
        this.endDate.setSeconds(0);
        this.availableLoadsFilter.beginDate = this.beginDate;
        this.availableLoadsFilter.endDate = this.endDate;
        //this.bookedLoadsFilter.beginDate = this.beginDate;
        //this.bookedLoadsFilter.endDate = this.endDate;
        //console.log(today, this.beginDate, this.endDate, this.availableLoadsFilter);
    }

    ngOnInit() {
        this.utilService.isLoading = false;
        this.isCSRManager = this.getIsCSRManager();
        this.availableLoadsFilter.isMyLoads = (this.isCSRManager != true);
        //this.bookedLoadsFilter.isMyLoads = (this.isCSRManager != true);
        if (this.isCSRManager) {
            this.selectedTab = "Dashboard";
        }

        this.originControl.disable();
        this.destinationControl.disable();

        this.getEmployees();
        this.getSearchEmployeeGroupRoles();
        this.getSearchEmployeeGroupRoleMaps();
        this.getLoads(false);

        this.initRecordLock();
    }

    ngOnDestroy() {
        if (this.editedLoad.quoteOrderID > 0 && this.offerID > 0) {
            this.recordLockService.clearRecordLock("QuoteOrder", this.editedLoad.quoteOrderID, this.recordLockSource);
        }
        else if (this.editedBookedLoad.quoteOrderID > 0 && this.offerID > 0) {
            this.recordLockService.clearRecordLock("QuoteOrder", this.editedBookedLoad.quoteOrderID, this.recordLockSource);
        }
        this.clearRecordLockList();
    }

    public getLoads(isRefresh: boolean) {
        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierSalesAvailableLoadsByDateRange(this.availableLoadsFilter.beginDate!, this.availableLoadsFilter.endDate!).subscribe(result => {
            this.utilService.isLoading = false;
            this.availableLoadsOrig = result.resultCollection;
            this.availableLoadsOrig.forEach(load => {
                if (load.arrivalStartDate != null) {
                    load.arrivalStartDate = new Date(load.arrivalStartDate!);
                }
            });

            this.filterLoads();
            if (isRefresh) {
                this.selectCurrentTab();
            }
        });
        this.getBookedLoads(isRefresh);
        this.getReleasedLoads(isRefresh);
        this.getUnverifiedLoads(isRefresh);

        if (this.isCSRManager) {
            this.getDashboardAvailableLoads();
            this.getDashboardBookedLoads();
            this.getDashboardUnverifiedLoads();
        }
    }

    private getDashboardAvailableLoads() {
        this.availableWithoutHCList = [];
        this.availableWithoutMaxCarrierPayList = [];
        var fromDate: Date = this.dashboardDate;
        //var toDate: Date = this.utilService.addDays(fromDate, 1);
        var toDate = fromDate;

        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierSalesAvailableLoadsByDateRange(fromDate, toDate).subscribe(result => {
            this.utilService.isLoading = false;

            var loads: SearchCarrierSalesAvailableLoads[] = result.resultCollection;
            loads = loads.filter(f =>
                (f.loadType == "ORD" || f.loadType == "CG")
                && f.carrierID == 0
            );
            loads.forEach(load => {
                if (load.arrivalStartDate != null) {
                    load.arrivalStartDate = new Date(load.arrivalStartDate!);
                }
                load.createdDate = new Date(load.createdDate);
            });

            //var minus15 = this.utilService.getDateAsUTC(new Date());
            var minus15 = this.utilService.getLocalDateInUTC(new Date());
            minus15 = this.utilService.addMinutes(minus15, -15);
            this.availableWithoutHCList = loads.filter(t =>
                (t.offers == null || t.offers == 0)
                && t.createdDate <= minus15
            );
            this.availableWithoutMaxCarrierPayList = loads.filter(t => t.maxCarrierPay == null || t.maxCarrierPay == 0);

            this.cardAvailableWithoutHC = this.availableWithoutHCList.length;
            this.cardAvailableWithoutMaxCarrierPay = this.availableWithoutMaxCarrierPayList.length;

            //console.log("getLoads", fromDate, toDate, this.cardAvailableWithoutHC, this.cardAvailableWithoutMaxCarrierPay, loadsBeginDate, loadsToday);
        });
    }

    public getDashboardBookedLoads() {
        this.bookedNegativeProfitList = [];
        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierSalesBookedLoadsNegativeProfit().subscribe(result => {
            this.utilService.isLoading = false;

            var loads = result.resultCollection;
            loads.forEach(load => {
                if (load.arrivalStartDate != null) {
                    load.arrivalStartDate = new Date(load.arrivalStartDate!);
                }
            });

            this.bookedNegativeProfitList = loads;
            this.cardBookedNegativeProfit = this.bookedNegativeProfitList.length;
        });
    }

    public getDashboardUnverifiedLoads() {
        this.unverifiedInTransitList = [];
        this.cardUnverifiedInTransitOrigList = [];
        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierSalesUnverifiedLoadsInTransit().subscribe(result => {
            this.utilService.isLoading = false;

            var loads: SearchCarrierSalesUnverifiedLoads[] = result.resultCollection;
            loads = loads.filter(t => t.isExcludeVerification == false);

            loads.forEach(load => {
                if (load.arrivalStartDate != null) {
                    load.arrivalStartDate = new Date(load.arrivalStartDate!);
                }
                if (load.pickupCity.length > 0
                    && load.driverName.length > 0
                    && (load.driverPhone.length > 0 || load.driverCell.length > 0)
                    && load.truckNumber.length > 0
                    && load.trailerNumber.length > 0) {
                    load.hasInfo = "Yes";
                    load.hasInfoClass = "text-success";
                }
                if (load.pickupCity.length < 1
                    || load.driverName.length < 1
                    || (load.driverPhone.length < 1 && load.driverCell.length < 1)
                    || load.truckNumber.length < 1
                    || load.trailerNumber.length < 1) {
                    load.hasInfo = "No";
                    load.hasInfoClass = "text-danger";
                }
                load.mpSetup = "";
                if (load.isExcludeMacropoint == true) {
                    load.mpSetup = "Not Required";
                    load.mpSetupClass = "text-success";
                }
                else if (load.macropointOrderID != 0) {
                    load.mpSetup = load.macropointStatusMessage;
                    if (load.isMacropointException) {
                        load.mpSetupClass = "text-danger";
                    }
                    else {
                        load.mpSetupClass = "text-success";
                    }
                }
                else if ((load.macropointOrderID == null || load.macropointOrderID == 0 || load.macropointStatusMessage == null || load.macropointStatusMessage.length < 1) && load.isMacropointException != true) {
                    load.mpSetup = "Not Setup";
                    load.mpSetupClass = "text-danger";
                }
            });

            this.unverifiedInTransitList = loads;
            var csrIDList = [...new Set(this.unverifiedInTransitList.map(item => item.awardedCarrierRepID))];
            for (var i = 0; i < csrIDList.length; i++) {
                this.getCardUnverifiedCSR(csrIDList[i]!);
            }

            // Sort cards by name
            this.cardUnverifiedInTransitOrigList = this.cardUnverifiedInTransitOrigList.sort((left, right): number => {
                if (left.employeeName < right.employeeName) return -1;
                if (left.employeeName > right.employeeName) return 1;
                return 0;
            });

            this.cardUnverifiedInTransitList = Object.assign([], this.cardUnverifiedInTransitOrigList);
            //var cardUnverifiedInTransitCSRList =
            //var awd: SearchCarrierSalesUnverifiedLoads;
            //awd.awardedCarrierRepID;
            //awd.bookedByCarrierRepName;
            console.log("getDashboardUnverifiedLoads", csrIDList);
        });
    }

    public getCardUnverifiedCSR(employeeID: number) {
        var loadList = this.unverifiedInTransitList.filter(t => t.awardedCarrierRepID == employeeID);
        var loadCount: EmployeeLoadCount = {
            employeeID: employeeID,
            employeeName: loadList[0].bookedByCarrierRepName,
            loadCount: loadList.length
        }
        this.cardUnverifiedInTransitOrigList.push(loadCount);
    }

    public cardClick(cardType: string, cardEmployeeID: number) {
        this.isCardDetail = true;
        this.cardType = cardType;
        this.cardEmployeeID = cardEmployeeID;
        this.unverifiedInTransitByEmployeeList = this.unverifiedInTransitList.filter(t => t.awardedCarrierRepID == cardEmployeeID);
    }

    private getSearchEmployeeGroupRoles() {
        // Carrier Sales Team employees
        this.employeeService.getSearchEmployeeGroupRolesByEmployeeRoleName("Carrier Sales Team").subscribe(result => {
            this.searchEmployeeGroupRoles = result.resultCollection;
        });
    }

    private getSearchEmployeeGroupRoleMaps() {
        // Dropdown for Carrier Sales Team Groups
        this.employeeService.getSearchEmployeeGroupRoleMapsByEmployeeRoleName("Carrier Sales Team").subscribe(result => {
            this.searchEmployeeGroupRoleMaps = result.resultCollection;
        });
    }

    public getTeam() {
        if (this.employeeGroupRoleMapID > 0) {
            var empList = this.searchEmployeeGroupRoles.filter(t => t.employeeGroupRoleMapID == this.employeeGroupRoleMapID);
            this.cardUnverifiedInTransitList = [];
            for (var i = 0; i < empList.length; i++) {
                var loadList = this.cardUnverifiedInTransitOrigList.filter(t => t.employeeID == empList[i].employeeID);
                this.cardUnverifiedInTransitList = this.cardUnverifiedInTransitList.concat(loadList);
            }
            //var employeeID: number = 0;
            //if (emp != null) {
            //    employeeID = emp.employeeID;
            //}
            //this.cardUnverifiedInTransitList = this.cardUnverifiedInTransitOrigList.filter(t => t.employeeID == employeeID);
        }
        else {
            this.cardUnverifiedInTransitList = Object.assign([], this.cardUnverifiedInTransitOrigList);
        }
    }

    public closeCardDetail() {
        this.isCardDetail = false;
        this.cardType = "";
        this.cardEmployeeID = 0;
    }

    public getBookedLoads(isRefresh: boolean) {
        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierSalesBookedLoadsByDateRange(this.availableLoadsFilter.beginDate!, this.availableLoadsFilter.endDate!).subscribe(result => {
            this.utilService.isLoading = false;
            this.bookedLoadsOrig = result.resultCollection;
            this.bookedLoadsOrig.forEach(load => {
                if (load.arrivalStartDate != null) {
                    load.arrivalStartDate = new Date(load.arrivalStartDate!);
                }
            });
            this.filterBookedLoads();
            if (isRefresh) {
                this.selectCurrentTab();
            }
        });
    }

    public getReleasedLoads(isRefresh: boolean) {
        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierSalesReleasedLoadsByDateRange(this.availableLoadsFilter.beginDate!, this.availableLoadsFilter.endDate!).subscribe(result => {
            this.utilService.isLoading = false;
            this.releasedLoadsOrig = result.resultCollection;
            //this.releasedLoadsOrig = this.releasedLoadsOrig.filter(t => t.loadStatus == "Released");
            this.releasedLoadsOrig.forEach(load => {
                if (load.arrivalStartDate != null) {
                    load.arrivalStartDate = new Date(load.arrivalStartDate!);
                }
            });
            this.filterReleasedLoads();
            if (isRefresh) {
                this.selectCurrentTab();
            }
        });
    }

    public getUnverifiedLoads(isRefresh: boolean) {
        this.utilService.isLoading = true;
        this.cseService.getSearchCarrierSalesUnverifiedLoadsByDateRange(this.availableLoadsFilter.beginDate!, this.availableLoadsFilter.endDate!).subscribe(result => {
            this.utilService.isLoading = false;
            this.unverifiedLoadsOrig = result.resultCollection;
            this.unverifiedLoadsOrig.forEach(load => {
                if (load.arrivalStartDate != null) {
                    load.arrivalStartDate = new Date(load.arrivalStartDate!);
                }
                if (load.pickupCity.length > 0
                    && load.driverName.length > 0
                    && (load.driverPhone.length > 0 || load.driverCell.length > 0)
                    && load.truckNumber.length > 0
                    && load.trailerNumber.length > 0) {
                    load.hasInfo = "Yes";
                    load.hasInfoClass = "text-success";
                }
                if (load.pickupCity.length < 1
                    || load.driverName.length < 1
                    || (load.driverPhone.length < 1 && load.driverCell.length < 1)
                    || load.truckNumber.length < 1
                    || load.trailerNumber.length < 1) {
                    load.hasInfo = "No";
                    load.hasInfoClass = "text-danger";
                }
                load.mpSetup = "";
                if (load.isExcludeMacropoint == true) {
                    load.mpSetup = "Not Required";
                    load.mpSetupClass = "text-success";
                }
                else if (load.macropointOrderID != 0) {
                    load.mpSetup = load.macropointStatusMessage;
                    if (load.isMacropointException) {
                        load.mpSetupClass = "text-danger";
                    }
                    else {
                        load.mpSetupClass = "text-success";
                    }
                }
                else if ((load.macropointOrderID == null || load.macropointOrderID == 0 || load.macropointStatusMessage == null || load.macropointStatusMessage.length < 1) && load.isMacropointException != true) {
                    load.mpSetup = "Not Setup";
                    load.mpSetupClass = "text-danger";
                }
            });

            this.filterUnverifiedLoads();
            if (isRefresh) {
                this.selectCurrentTab();
            }
        });
    }

    public resetFilters() {
        //this.availableLoadsFilter = {
        //    beginDate: new Date   (new Date().setDate(new Date().getDate() - 1)),
        //    endDate: new Date(new Date().setDate(new Date().getDate() + 10)),
        //    isSpotExpediteContract: false,
        //    isMyLoads: false,
        //    isBulkTender: false
        //};
        this.availableLoadsFilter.isSpotExpediteContract = false;
        this.availableLoadsFilter.isRFQAllCosts = false;
        this.availableLoadsFilter.isMyLoads = false;
        this.availableLoadsFilter.isBulkTender = false;
        this.filterLoads();
        this.filterBookedLoads();
        this.filterUnverifiedLoads();
    }

    public onTabSelect(evt: any) {
        this.selectedTab = evt.title;
        if (evt.title != "RFQ") {
            this.availableLoadsFilter.isRFQAllCosts = false;
        }
        if (evt.title == "Quotes" || evt.title == "RFQ") {
            //var loadsWithDates: SearchCarrierSalesAvailableLoads[] = Object.assign([], this.availableLoadsOrig);
            //loadsWithDates = loadsWithDates.filter(t => t.arrivalStartDate != null);
            //var dates = loadsWithDates.map(function (t) { return new Date(t.arrivalStartDate!); });
            //var minDate = (dates) => new Date(Math.min(...dates));
            //var maxDate = (dates) => new Date(Math.max(...dates));
            //this.availableLoadsFilter.beginDate = new Date(new Date().setDate(new Date().getDate() - 7));
            //this.availableLoadsFilter.endDate = maxDate(dates);
            this.filterLoads();
            //console.log("onTabSelect:RFQ", minDate, maxDate);
        }
        else if (evt.title == "Open Dedicated") {
            //var loadsWithDates: SearchCarrierSalesAvailableLoads[] = Object.assign([], this.availableLoadsOrig);
            //loadsWithDates = loadsWithDates.filter(t => t.arrivalStartDate != null);
            //var dates = loadsWithDates.map(function (t) { return new Date(t.arrivalStartDate!); });
            //var minDate = (dates) => new Date(Math.min(...dates));
            //var maxDate = (dates) => new Date(Math.max(...dates));
            //this.availableLoadsFilter.beginDate = minDate(dates);
            //this.availableLoadsFilter.endDate = maxDate(dates);
            this.filterLoads();
            //console.log("onTabSelect:RFQ", minDate, maxDate);
        }
        else {
            this.filterLoads();
            //this.availableLoadsFilter.beginDate = this.beginDate;
            //this.availableLoadsFilter.endDate = this.endDate;
        }
        //console.log("onTabSelect", evt);
    }

    public onContactsLanesTabSelect(evt: any) {
        //console.log("onContactsLanesTabSelect", evt);
    }

    public filterLoads() {
        //this.availableLoads = JSON.parse(JSON.stringify(this.availableLoadsOrig));;
        this.availableLoads = Object.assign([], this.availableLoadsOrig);

        //if (this.availableLoadsFilter.beginDate) {
        //    this.availableLoads = this.availableLoads.filter(f => f.arrivalStartDate! >= this.availableLoadsFilter.beginDate!);
        //}
        //if (this.availableLoadsFilter.endDate) {
        //    this.availableLoads = this.availableLoads.filter(f => f.arrivalStartDate! <= this.availableLoadsFilter.endDate!);
        //}
        if (this.availableLoadsFilter.isMyLoads == true && this.availableLoadsFilter.isSpotExpediteContract == true) {
            this.availableLoads = this.availableLoads.filter(f =>
                //f.erpAssignedTo != null
                //&&
                //(
                //    f.quoteOrderID.toString() != f.orderNumber && f.erpAssignedTo != null && (f.erpAssignedTo.toUpperCase() == "CG" || f.erpAssignedTo.toUpperCase() == "AAVAILABLE" || f.erpAssignedTo.toUpperCase() == "UNKNOWN")
                //    || f.quoteOrderID.toString() == f.orderNumber && (f.rateIndex == "Spot" || f.rateIndex == "Expedite" || f.rateIndex == "Contract" && (f.assignedToName == "" || f.assignedToName == null))
                //)
                (f.rateIndex == "Spot" || f.rateIndex == "Expedite" || f.rateIndex == "Contract" && (f.assignedToName == "" || f.assignedToName == null))
                && f.assignedToName != null
                && f.assignedToName.toUpperCase().indexOf(this.userName) >= 0
            );
        }
        else if (this.availableLoadsFilter.isMyLoads == true) {
            this.availableLoads = this.availableLoads.filter(f =>
                f.assignedToName != null
                && f.assignedToName.toUpperCase().indexOf(this.userName) >= 0
            );
        }
        else if (this.availableLoadsFilter.isSpotExpediteContract == true) {
            this.availableLoads = this.availableLoads.filter(f =>
                //f.erpAssignedTo != null
                //&&
                //(
                //f.quoteOrderID.toString() != f.orderNumber && f.erpAssignedTo != null && (f.erpAssignedTo.toUpperCase() == "CG" || f.erpAssignedTo.toUpperCase() == "AAVAILABLE" || f.erpAssignedTo.toUpperCase() == "UNKNOWN")
                //    || f.quoteOrderID.toString() == f.orderNumber && (f.rateIndex == "Spot" || f.rateIndex == "Expedite" || f.rateIndex == "Contract" && (f.assignedToName == "" || f.assignedToName == null))
                //)
                (f.rateIndex == "Spot" || f.rateIndex == "Expedite" || f.rateIndex == "Contract" && (f.assignedToName == "" || f.assignedToName == null))
            );
        }
        if (this.selectedTab == "RFQ") {
            //this.availableLoads = this.availableLoads.filter(f =>
            //    f.loadType == "RFQ" && f.finalCost == 0
            //    || f.loadType == "RFQP"
            //);
            if (this.availableLoadsFilter.isRFQAllCosts == true) {
                this.availableLoads = this.availableLoads.filter(f => f.quoteOrderLineType == "RFQ" || f.quoteOrderLineType == "RFQP");
            }
            else {
                this.availableLoads = this.availableLoads.filter(f => f.finalCost == 0 && (f.quoteOrderLineType == "RFQ" || f.quoteOrderLineType == "RFQP"));
            }
        }
        if (this.availableLoadsFilter.isBulkTender == true) {
            //this.availableLoads = this.availableLoads.filter(f => f.assignedToName.indexOf(",") < 0);
            this.availableLoads = this.availableLoads.filter(f => f.quoteOrderLineType != "CG");
        }
        else {
            this.bulkTenderLoads.length = 0;
        }
        //console.log("filterLoads", this.availableLoadsFilter, this.availableLoads.length, this.availableLoadsOrig.length, this.bulkTenderLoads);
    }

    public filterBookedLoads() {
        this.bookedLoads = JSON.parse(JSON.stringify(this.bookedLoadsOrig));;
        this.bookedLoads = Object.assign([], this.bookedLoadsOrig);

        //if (this.availableLoadsFilter.beginDate) {
        //    this.bookedLoads = this.bookedLoads.filter(f => f.arrivalStartDate! >= this.availableLoadsFilter.beginDate!);
        //}
        //if (this.availableLoadsFilter.endDate) {
        //    this.bookedLoads = this.bookedLoads.filter(f => f.arrivalStartDate! <= this.availableLoadsFilter.endDate!);
        //}
        //if (this.bookedLoadsFilter.isMyLoads == true && this.bookedLoadsFilter.isSpotExpediteContract == true) {
        //    this.bookedLoads = this.bookedLoads.filter(f =>
        //        f.erpAssignedTo != null
        //        && (f.erpAssignedTo.toUpperCase() == "CG" || f.erpAssignedTo.toUpperCase() == "AAVAILABLE")
        //        || f.assignedToName != null
        //        && f.assignedToName.toUpperCase().indexOf(this.userName) >= 0
        //    );
        //}
        if (this.availableLoadsFilter.isMyLoads == true) {
            this.bookedLoads = this.bookedLoads.filter(f =>
                f.awardedCarrierRepID != null
                && f.awardedCarrierRepID == parseInt(localStorage.getItem('EmployeeId')!)
            //    f.assignedToName != null
            //    && f.assignedToName.toUpperCase().indexOf(this.userName) >= 0
            );
        }
        //else if (this.bookedLoadsFilter.isSpotExpediteContract == true) {
        //    this.bookedLoads = this.bookedLoads.filter(f =>
        //        f.erpAssignedTo != null
        //        && (f.erpAssignedTo.toUpperCase() == "CG" || f.erpAssignedTo.toUpperCase() == "AAVAILABLE")
        //    );
        //}
        //console.log("filterBookedLoads", this.availableLoadsFilter, this.bookedLoads.length, this.bookedLoadsOrig.length);
    }

    public filterReleasedLoads() {
        this.releasedLoads = JSON.parse(JSON.stringify(this.releasedLoadsOrig));;
        this.releasedLoads = Object.assign([], this.releasedLoadsOrig);

        if (this.availableLoadsFilter.isMyLoads == true) {
            this.releasedLoads = this.releasedLoads.filter(f =>
                f.awardedCarrierRepID != null
                && f.awardedCarrierRepID == parseInt(localStorage.getItem('EmployeeId')!)
            );
        }
        //console.log("filterReleasedLoads", this.availableLoadsFilter, this.releasedLoads.length, this.releasedLoadsOrig.length);
    }

    public filterUnverifiedLoads() {
        this.unverifiedLoads = JSON.parse(JSON.stringify(this.unverifiedLoadsOrig));;
        this.unverifiedLoads = Object.assign([], this.unverifiedLoadsOrig);

        //if (this.availableLoadsFilter.beginDate) {
        //    this.unverifiedLoads = this.unverifiedLoads.filter(f => f.arrivalStartDate! >= this.availableLoadsFilter.beginDate!);
        //}
        //if (this.availableLoadsFilter.endDate) {
        //    this.unverifiedLoads = this.unverifiedLoads.filter(f => f.arrivalStartDate! <= this.availableLoadsFilter.endDate!);
        //}
        if (this.availableLoadsFilter.isMyLoads == true) {
            this.unverifiedLoads = this.unverifiedLoads.filter(f =>
                f.awardedCarrierRepID != null
                && f.awardedCarrierRepID == parseInt(localStorage.getItem('EmployeeId')!)
                //    f.assignedToName != null
                //    && f.assignedToName.toUpperCase().indexOf(this.userName) >= 0
            );
        }
        //console.log("filterUnverifiedLoads", this.availableLoadsFilter, this.unverifiedLoads.length, this.unverifiedLoadsOrig.length);
    }

    public getOrderNumber() {
        if (this.bulkTenderLoads.length > 0) {
            var orderNumber = "";
            for (var i = 0; i < this.bulkTenderLoads.length; i++) {
                if (i > 0) {
                    orderNumber += ", ";
                }
                orderNumber += this.bulkTenderLoads[i].orderNumber;
            }
            return orderNumber;
        }
        else {
            return this.editedLoad.orderNumber;
        }
    }

    private getIsCSRManager() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('Carrier Sales Manager') > -1) return true;
        }

        return false;
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('Account Managers').subscribe(result => {
            this.accountReps = result;
        });

        this.employeeService.getEmployeesByGroupName('Sales').subscribe(result => {
            this.salesReps = result;
        });

        this.employeeService.getEmployeesByGroupName('Ops Rep').subscribe(result => {
            this.opsReps = result;
        });

        //this.employeeService.getAllEmployees().subscribe(result => {
        //    this.employees = result;

        //    var empID = localStorage.getItem('EmployeeId');
        //    if (empID && parseInt(empID)) {
        //        var emp = this.employees.find(e => e.employeeId == parseInt(empID!));
        //        if (emp) {
        //            this.userName = emp.winUserName.toUpperCase();
        //        }
        //        //console.log("ngOnInit", empID, this.isCSRManager, this.userName, this.availableLoadsFilter, emp);
        //    }
        //});
        var empID = localStorage.getItem('EmployeeId');
        if (empID && parseInt(empID)) {
            this.employeeService.getEmployeeById(parseInt(empID)).subscribe(result => {
                var emp = result;
                if (emp) {
                    this.userName = emp.winUserName.toUpperCase();
                }
            });
            //console.log("ngOnInit", empID, this.isCSRManager, this.userName, this.availableLoadsFilter, emp);
        }
    }

    public getModeDescription(line: QuoteOrderLine): string {
        var mode = this.modes.filter(m => m.modeID == line.modeID);

        if (mode == null || mode.length < 1) return '';

        return mode[0].description;
    }

    public getTrailerTypeDescription(line: QuoteOrderLine): string {
        var trailerType = this.trailerTypes.filter(t => t.trailerTypeID == line.trailerTypeID);

        if (trailerType == null || trailerType.length < 1) return '';

        return trailerType[0].description;
    }

    public loadClick(load: SearchCarrierSalesAvailableLoads) {
        //console.log("carrier-sales.loadClick", load);
        this.closeLoad();

        this.originalQuoteOrderLineID = load.quoteOrderLineID;

        // Check if click is coming from Booked loads and open directly to the awarded offer
        if (load.awardedOfferID && load.awardedOfferID > 0) {
            //console.log("carrier-sales.loadClick:awardedOfferID", load.awardedOfferID);
            this.offerID = load.awardedOfferID;
            this.editedBookedLoad = load;
        }

        if (load.isAwarded != true && load.offerBatchID && load.offerBatchID > 0) {
            //console.log("carrier-sales.loadClick:offerBatchID", load.offerBatchID);
            this.offerBatchID = load.offerBatchID;
            this.availableLoadsFilter.isBulkTender = true;
            this.filterLoads();
            //this.bulkTenderLoads
            //this.editedBookedLoad = load;
        }

        this.orderService.getSearchQuoteOrderLineByQuoteOrderLineID(load.quoteOrderLineID);
        this.getQuoteOrderLine(load);
    }

    public unverifiedLoadClick(load: SearchCarrierSalesAvailableLoads) {
        //console.log("carrier-sales.unverifiedLoadClick", load);
        this.closeLoad();

        //this.originalQuoteOrderLineID = load.quoteOrderLineID;

        // Check if click is coming from Booked loads and open directly to the awarded offer
        if (load.awardedOfferID && load.awardedOfferID > 0) {
            //console.log("carrier-sales.unverifiedLoadClick:awardedOfferID", load.awardedOfferID);
            this.offerID = load.awardedOfferID;
            this.editedBookedLoad = load;
        }

        this.orderService.getSearchQuoteOrderLineByQuoteOrderLineID(load.quoteOrderLineID);
        this.getQuoteOrderLine(load);
    }

    public offerLoadClick(quoteOrderLineID: number) {
        var loads: SearchCarrierSalesAvailableLoads[] = this.availableLoadsOrig.filter(t => t.quoteOrderLineID == quoteOrderLineID);
        if (loads.length > 0) {
            this.closeLoad();
            var load: SearchCarrierSalesAvailableLoads = Object.assign({}, loads[0]);
            this.editedBookedLoad = load;
            //console.log("carrier-sales.offerLoadClick", quoteOrderLineID, load, this.editedBookedLoad);
            this.orderService.getSearchQuoteOrderLineByQuoteOrderLineID(quoteOrderLineID);
            this.getQuoteOrderLine(load);
        }
        else {
            this.notificationService.showWarning("Load not found.", "WARNING: Load Not Found");
        }
    }

    public selectBulkTenderLoads(loads: SearchCarrierSalesAvailableLoads[]) {
        if (loads.length > 0) {
            this.bulkTenderLoads = loads;
        }
        else {
            this.bulkTenderLoads.length = 0;
        }
        //console.log("carrier-sales.selectBulkTenderLoads", loads, this.bulkTenderLoads);
    }

    public offerBulkTenderLoads() {
        if (this.bulkTenderLoads.length > 0) {
            // Check/get lock for the batch orders before saving the offers
            var idList: number[] = [];
            this.bulkTenderLoads.forEach(bulkLoad => {
                idList.push(bulkLoad.quoteOrderID);
            });
            this.isTenderLoads = true;
            this.recordLockAction = "offerBulkTenderLoads";
            this.recordLockService.handleRecordLockList("QuoteOrder", idList, this.recordLockSource);
        }
    }

    private allowOfferBulkTenderLoads() {
        //console.log("offerBulkTenderLoads", this.bulkTenderLoads);
        //this.closeLoad();

        if (this.bulkTenderLoads.length > 0) {
            var load: SearchCarrierSalesAvailableLoads = this.bulkTenderLoads[0];
            //console.log("offerBulkTenderLoads:load", load);
            this.utilService.isLoading = true;
            this.orderService.getSearchQuoteOrderLineByQuoteOrderLineID(load.quoteOrderLineID);
            this.getQuoteOrderLine(load);
            //this.availableLoadsFilter.isBulkTender = false;
        }
    }

    private getQuoteOrderLine(load: SearchCarrierSalesAvailableLoads) {
        var name = "getSearchQuoteOrderLineByQuoteOrderLineID-" + load.quoteOrderLineID;
        if (this.subQuoteOrderLine) {
            this.subQuoteOrderLine.unsubscribe();
        }
        var data = this.dataService.get(name);
        if (data) {
            this.utilService.isLoading = false;
            this.setupQuoteOrderLine(load, data);
            //console.log("carrier-sales:getQuoteOrderLine", load);
        }
        else {
            this.subQuoteOrderLine = this.dataService.currentDataCollection.subscribe(result => {
                this.utilService.isLoading = false;
                if (result.name == name) {
                    this.setupQuoteOrderLine(load, result);
                    //console.log("carrier-sales:getQuoteOrderLine", load, result);
                }
            });
        }
    }

    private setupQuoteOrderLine(load: SearchCarrierSalesAvailableLoads, result: DataCollection) {
        var line: SearchQuoteOrderLine = result.resultCollection[0];
        //console.log("carrier-sales:setupQuoteOrderLine", load, line, result);
        if (line.loadStatus == "Canceled") {
            this.notificationService.showWarning("This load is canceled. Please refresh the loads.", "WARNING: Load Canceled");
        }
        else {
        //    this.orderNumber = load.orderNumber;
        //    this.editedLoad = Object.assign({}, load);
        //    this.cseService.getOffersByLineId(this.editedLoad.quoteOrderLineID);
        }
        this.quoteOrderID = load.quoteOrderID;
        this.editedLoad = Object.assign({}, load);
        this.cseService.getOffersByLineId(this.editedLoad.quoteOrderLineID);
    }

    public carrierClick(evt: any) {
        //console.log("carrier-sales-carrierClick", evt);
        //this.refreshDate = new Date();

        this.carrierID = evt;
    }

    public bulkTenderOfferSave(evt: any) {
        //console.log("bulkTenderOfferSave", evt);
        this.offerBatchID = evt;
    }

    public awardOfferClick(evt: any) {
        //console.log("carrier-sales-awardOfferClick", evt);
        this.offerID = evt;
    }

    public closeLoad() {
        this.clearRecordLockList();
        //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
        //console.log("closeLoad");
        this.quoteOrderID = 0;
        this.carrierID = 0;
        this.offerID = 0;
        this.offerBatchID = 0;
        this.bulkTenderLoads.length = 0;
        this.isTenderLoads = false;
        this.availableLoadsFilter.isBulkTender = false;
        var emptyLoad: SearchCarrierSalesAvailableLoads = {} as SearchCarrierSalesAvailableLoads;
        this.editedLoad = emptyLoad;
        this.editedBookedLoad = emptyLoad;
    }

    //public saveDialogClick(evt: any) {
    //    this.isDialog = false;
    //}

    public openDialogClick(type: string) {
        if (type == "CarrierRepsAssignedStats") {
            this.isCarrierRepsAssignedStats = true;
        }
    }

    public cancelDialogClick(type: string) {
        if (type == "CarrierRepsAssignedStats") {
            this.isCarrierRepsAssignedStats = false;
        }
    }

    public refreshAfterOffer() {
        //console.log("refreshAfterOffer");
        this.closeLoad();
        this.getLoads(true);
        //    this.selectCurrentTab();
    }

    private selectCurrentTab() {
        console.log("selectCurrentTab", this.selectedTab, this.topTabStrip);
        //var maxTab: number = this.topTabStrip.tabs.length - 1;
        if (this.topTabStrip) {
            var idx = 0;
            var arr = this.topTabStrip.tabs.toArray();
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].title == this.selectedTab) {
                    idx = i;
                }
            }
            this.topTabStrip.selectTab(idx);
            //if (this.selectedTab == "Dashboard") {
            //    this.topTabStrip.selectTab(maxTab - 8);
            //}
            //else if (this.selectedTab == "Orders") {
            //    this.topTabStrip.selectTab(maxTab - 7);
            //}
            //else if (this.selectedTab == "Booked") {
            //    this.topTabStrip.selectTab(maxTab - 6);
            //}
            //else if (this.selectedTab == "Unverified") {
            //    this.topTabStrip.selectTab(maxTab - 5);
            //}
            //else if (this.selectedTab == "Quotes") {
            //    this.topTabStrip.selectTab(maxTab - 4);
            //}
            //else if (this.selectedTab == "RFQ") {
            //    this.topTabStrip.selectTab(maxTab - 3);
            //}
            //else if (this.selectedTab == "Open Dedicated") {
            //    this.topTabStrip.selectTab(maxTab - 2);
            //}
            //else if (this.selectedTab == "Lane") {
            //    this.topTabStrip.selectTab(maxTab - 1);
            //}
            //else if (this.selectedTab == "Open Offers") {
            //    this.topTabStrip.selectTab(maxTab);
            //}
            //else {
            //    this.topTabStrip.selectTab(0);
            //}
        }
    }

    public refreshData(evt: any) {
        if (evt == "carrier") {
            this.carrierRefreshDate = new Date();
        }
        else if (evt == "offer") {
            this.offerRefreshDate = new Date();
        }
    }

    public cancelOffer() {
        //console.log("cancelOffer");
        if (this.editedBookedLoad && this.editedBookedLoad.isAwarded == true || this.offerBatchID > 0) {
            this.refreshAfterOffer();
        }
        else {
            this.offerID = 0;
        }
    }

    public toggleFlag(div: string) {
        this.divFlags[div] = !this.divFlags[div];
    }

    public updateEditedLoad(load: SearchCarrierSalesAvailableLoads) {
        this.quoteOrderID = 0;
        //this.carrierID = 0;
        this.offerID = 0;
        this.offerBatchID = 0;
        this.bulkTenderLoads.length = 0;
        this.availableLoadsFilter.isBulkTender = false;
        //var emptyLoad: SearchCarrierSalesAvailableLoads = {} as SearchCarrierSalesAvailableLoads;
        //this.editedLoad = emptyLoad;
        //this.editedBookedLoad = emptyLoad;

        this.orderService.getSearchQuoteOrderLineByQuoteOrderLineID(load.quoteOrderLineID);
        this.getQuoteOrderLine(load);
        //console.log("carrier-sales:updateEditedLoad", load);
    }

    private clearRecordLockList() {
        this.recordLockAction = "";
        if (this.bulkTenderLoads.length > 0) {
            // Check/get lock for the batch orders before saving the offers
            var idList: number[] = [];
            this.bulkTenderLoads.forEach(bulkLoad => {
                idList.push(bulkLoad.quoteOrderID);
            });
            this.recordLockService.clearRecordLockList("QuoteOrder", idList, this.recordLockSource);
        }
        //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
    }

    private initRecordLock() {
        this.recordLockService.resetRecordLock();
        this.recordLockAction = "";
        this.recordLockSource = "Procurement";
        //if (this.recordLockService.continueRecordLockObserver.observers.length < 2) {
        //}
        //if (this.recordLockService.cancelOverrideObserver.observers.length < 2) {
        //}
        //if (this.recordLockService.timeoutRecordLockObserver.observers.length < 2) {
        //}
        //if (this.recordLockService.timeoutConfirmObserver.observers.length < 2) {
        //}
        this.recordLockService.continueRecordLockObserver.subscribe(result => {
            console.log("carrier-sales:initRecordLock:isContinueRecordLock", this.recordLockService.isContinueRecordLock);
            if (this.recordLockService.isContinueRecordLock) {
                if (!this.recordLockService.isLocked && this.recordLockAction == "offerBulkTenderLoads") {
                    this.allowOfferBulkTenderLoads();
                }
                else {
                    this.isTenderLoads = false;
                }
            }
            else {
                this.isTenderLoads = false;
            }
        });
        this.recordLockService.cancelOverrideObserver.subscribe(result => {
            console.log("carrier-sales:initRecordLock:isCancelOverride", this.recordLockService.isCancelOverride);
            if (this.recordLockService.isCancelOverride) {
                this.recordLockService.resetRecordLock();
                //this.cancelOffer();
            }
        });
        this.recordLockService.timeoutRecordLockObserver.subscribe(result => {
            if (this.recordLockService.isRecordLockTimeout) {
                //console.log("tracking-dashboard:handleRecordLock:isRecordLockTimeout", this.recordLockAction, this.quoteOrderID, this.recordLockService.searchRecordLock);
                var idList: number[] = [];
                this.bulkTenderLoads.forEach(bulkLoad => {
                    idList.push(bulkLoad.quoteOrderID);
                });
                this.recordLockService.clearRecordLockList("QuoteOrder", idList, this.recordLockSource);
                //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
                //this.continueRecordLockAction();
            }
        });
        this.recordLockService.timeoutConfirmObserver.subscribe(result => {
            if (this.recordLockService.isConfirmTimeout) {
                //console.log("tracking-dashboard:handleRecordLock:timeoutConfirmObserver", this.recordLockAction, this.quoteOrderID, this.recordLockService.searchRecordLock);
                this.recordLockService.resetRecordLock();
                //this.navigateQuoteOrder(this.quoteOrderID, true);
                this.refreshAfterOffer();
            }
        });
    }
}
